import api from './api';

// 新增活动
export const addLetsBasketball = params => {
  // '/v1/management/letsBasketball/add-activity'
  return api("post", '/v2/management/letsBasketball/add-activity', params);
};
// 删除活动
export const delLetsBasketball = id => {
  return api("delete", `/v1/management/letsBasketball/del-activity/${id}`);
};
// 活动详情
export const getLetsBasketballDetail = id => {
  // `/v1/management/letsBasketball/detail/${id}`
  return api("get", `/v2/management/letsBasketball/detail/${id}`);
};
// 编辑活动
export const editLetsBasketball = params => {
  // /v1/management/letsBasketball/edit-activity
  return api("post", '/v2/management/letsBasketball/edit-activity', params);
};
// 更新三篮精彩视频
export const editLetsBasketballVideo = params => {
  return api("post", '/v2/management/letsBasketball/excitingVideos', params);
};
// 获取三篮精彩视频详情
export const getLetsBasketballVideoDetail = params => {
  return api("post", '/v2/management/letsBasketball/excitingVideosDetails', params);
};
// 导出活动报名名单
export const exportEnrollmentList = id => {
  // `/v1/management/letsBasketball/exportEnrollmentList/${id}`
  return api("get", `/v2/management/letsBasketball/exportEnrollmentList/${id}`, {},
    {
      responseType: "blob",
    });
};
// 活动列表展示
export const postLetsBasketballList = params => {
  return api("post", `/v1/management/letsBasketball/list`, params);
};
// 下架活动
export const offlineLetsBasketball = params => {
  return api("post", `/v1/management/letsBasketball/offline-activities`, params);
};
// 开放报名
export const openRegistration = params => {
  return api("post", `/v1/management/letsBasketball/openRegistration`, params);
};
// 发布活动
export const releaseLetsBasketball = params => {
  return api("post", `/v1/management/letsBasketball/release-activities`, params);
};
// 活动类型列表
export const getLetsBasketballType = params => {
  return api("get", `/v1/management/letsBasketball/type-list`, params);
};
// 上传用户活动数据
export const uploadLetsBasketball = params => {
  // 配置请求头部为表单式
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  // return api("post", `/v1/management/letsBasketball/uploadUserActivityList`, params);
  return api("put", `/v2/management/letsBasketball/upload-personal-data`, params, config);
};
// 上传球队活动数据
export const uploadTeamLetsBasketball = params => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("put", `/v2/management/letsBasketball/upload-team-data`, params, config);
};
// 上传队伍信息
export const importUserManuallyRegistrationList = params => {
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return api("put", `/v1/management/letsBasketball/importUserManuallyRegistrationList`, params, config);
};
// 导出身份证信息表
export const exampleExportTheIDCardInformationTable = id => {
  return api("get", `/v1/management/letsBasketball/exampleExportTheIDCardInformationTable/${id}`,
    {},
    {
      responseType: "blob",
    });
};
// 三人篮球商品列表展示
export const getLetslist = () => {
  return api("post", '/v1/management/equipment-lets/list');
};
// 保存三人篮球商品
export const saveLetsEquipment = params => {
  return api("post", '/v1/management/equipment-lets/saveEquipment', params);
};
